import { env, Runtime } from './env';

/**
 * Name: Logan 日志
 */
class LoganLog {
  private config: any = {}
  private isDev: boolean = true;

  constructor(isDev: boolean) {
    if (!Logan) {
      return;
    }
    this.isDev = isDev;
    this.init();
    Logan.config(this.config);
  }

  init() {
    this.config = {
      devMode: this.isDev
    };
  }
}

const isProduct = env.runtime === Runtime.Prod;

export const logan = new LoganLog(!isProduct);
